import React from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import { Card, CardContent } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { monthLabel, rupee } from "./format";

export const MonthlyChart = ({ data, showCum, setShowCum }) => {
  if (!data) return null;
  const rows = data.months.map((m, i) => ({ month: monthLabel(m), spent: data.total[i], cumulative: data.cumulative[i] }));
  return (
    <Card data-testid="report-monthly-chart">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-2">
          <div className="text-sm font-semibold">Spending per month · {data.fy} · FY total {rupee(data.fy_total)}</div>
          <label className="flex items-center gap-2 text-xs text-slate-600">
            <Switch checked={showCum} onCheckedChange={setShowCum} data-testid="report-chart-cumulative-toggle" /> Cumulative line
          </label>
        </div>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={rows} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="month" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => (v >= 100000 ? `${(v / 100000).toFixed(1)}L` : v.toLocaleString("en-IN"))} />
              <Tooltip formatter={(v) => rupee(v)} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="spent" name="Spent in month" fill="#2563eb" radius={[3, 3, 0, 0]} />
              {showCum && <Line type="monotone" dataKey="cumulative" name="Cumulative" stroke="#f59e0b" strokeWidth={2} dot={false} />}
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};
